import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OCC_USER_ID_ANONYMOUS } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Feed } from '../../../model/feed.model';
import { normalizeHttpError } from '../../../util';
import { FeedConnector } from '../../connectors/feed.connector';
import { UserActions } from '../actions';

@Injectable()
export class FeedEffects {
  loadFeedData$: Observable<
    UserActions.LoadFeedDataSuccess | UserActions.LoadFeedDataFail | UserActions.LoadPartiallyFeedDataSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.FeedDataActionTypes.LOAD_FEED_DATA),
      filter((action: UserActions.LoadFeedData) => action.userId !== OCC_USER_ID_ANONYMOUS),
      switchMap((action: UserActions.LoadFeedData) =>
        this.feedConnector.getFeedData(action.userId, action.feedRequestList).pipe(
          map((feed: Feed) =>
            !!action.feedRequestList
              ? new UserActions.LoadPartiallyFeedDataSuccess(feed)
              : new UserActions.LoadFeedDataSuccess(feed)
          ),
          catchError((error: HttpErrorResponse) => of(new UserActions.LoadFeedDataFail(normalizeHttpError(error))))
        )
      )
    )
  );

  constructor(private actions$: Actions, private feedConnector: FeedConnector) {}
}
